import {useState} from 'react';

import {isNil} from 'ramda';

import {Nullish} from '../types/Nullish';

/** Alpha is the only logo source. Missing or failed images leave the identity text visible. */
export function useBrandImageUrl(catalogueLogoUrl: string | Nullish) {
  const [failedUrls, setFailedUrls] = useState<string[]>([]);
  const url = catalogueLogoUrl?.trim();
  const logoUrl = !isNil(url) && url !== '' && !failedUrls.includes(url) ? url : undefined;

  const onLogoError = () => {
    if (!isNil(logoUrl)) {
      setFailedUrls((urls) => [...urls, logoUrl]);
    }
  };

  return {logoUrl, onLogoError};
}
